var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagePatientProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#04B7B1;stroke-width:0.4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11710",
    transform: "translate(58.862 415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    className: "st0",
    d: "M-45.2-399c0.1-0.5-0.1-1-0.4-1.3c-0.4-0.3-0.9-0.4-1.4-0.3v-0.5c0-0.7-0.5-1.3-1.2-1.3l0,0 c-0.4,0-0.9,0-1.3,0c-0.7,0-1.2,0.6-1.2,1.3v0.6h-0.5c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0v0.3c-0.2,0-0.5-0.1-0.7-0.1 c-0.4-0.1-0.9-0.3-1.3-0.5c-1-0.4-1.4-1.5-1-2.5c0.1-0.2,0.2-0.5,0.4-0.6c0.5-0.5,1-0.8,1.6-1.1c0.7-0.4,1.4-0.7,2.1-1 c0.9-0.4,1-1,0.4-1.7c-0.6-0.8-1.1-1.7-1.4-2.6c-0.3-0.9-0.2-1.9,0-2.9c0.4-1.4,1.6-2.4,3.1-2.4c0.7-0.1,1.4,0,2.1,0.3 c1,0.5,1.7,1.5,1.8,2.6c0.3,1.6-0.2,3.3-1.2,4.5c-0.3,0.3-0.5,0.7-0.6,1.1c-0.1,0.4,0,0.8,0.4,1c0.3,0.2,0.7,0.4,1.1,0.5 c0.9,0.3,1.7,0.8,2.5,1.3c0.8,0.5,1.2,1.5,1,2.4c-0.1,0.4-0.3,0.8-0.7,1c-0.5,0.3-1.2,0.6-1.8,0.7C-44.8-399-45-399-45.2-399 L-45.2-399z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    className: "st0",
    d: "M-48.2-396h-1.3c-0.2,0-0.4-0.2-0.3-0.5v-1.4h-1.4c-0.2,0-0.4-0.1-0.5-0.4c0,0,0-0.1,0-0.1 c0-0.4,0-0.7,0-1.1c0-0.2,0.2-0.4,0.4-0.5c0,0,0.1,0,0.1,0h1.3v-1.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0c0.4,0,0.8,0,1.1,0 c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0,0,0.1v1.4h1.4c0.2,0,0.4,0.1,0.4,0.4c0,0,0,0,0,0c0,0.4,0,0.8,0,1.2c0,0.2-0.2,0.4-0.4,0.4 c0,0,0,0,0,0h-1.4v1.4C-47.9-396.2-48-396-48.2-396L-48.2-396z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagePatientProfile);
export default __webpack_public_path__ + "static/media/ManagePatientProfile.109f31fc.svg";
export { ForwardRef as ReactComponent };